import { getAuthoredOverview, renderAuthoredNarrativeBundle } from './authoredNarrativeRender';
import { shouldPublishAuthoredMethodology } from './authoredNarrativeLoader';

const CHART_ID = 'economic_sector_wages';

export type OccupationEarningsViewId = 'current' | 'trends' | 'comparison' | 'median-trend';

export function buildOccupationEarningsTokens(params: {
  locationName: string;
  latestYear: number | null;
  highestEarnings: number | null;
  lowestEarnings: number | null;
  highestCategory: string | null;
  lowestCategory: string | null;
}): Record<string, string> {
  return {
    locationName: params.locationName,
    latestYear: params.latestYear != null ? String(params.latestYear) : '—',
    highestEarnings:
      params.highestEarnings != null
        ? `$${Math.round(params.highestEarnings).toLocaleString()}`
        : '—',
    lowestEarnings:
      params.lowestEarnings != null
        ? `$${Math.round(params.lowestEarnings).toLocaleString()}`
        : '—',
    highestCategory: params.highestCategory ?? '—',
    lowestCategory: params.lowestCategory ?? '—',
    distributionSentence: '',
    trendSentence: '',
  };
}

export function buildOccupationEarningsAuthoredBundle(
  view: OccupationEarningsViewId,
  tokens: Record<string, string>
) {
  const bundle = renderAuthoredNarrativeBundle(CHART_ID, view === 'current' ? 'default' : view, tokens);
  if (!bundle.overview) {
    bundle.overview = getAuthoredOverview(CHART_ID, 'default', '');
  }
  if (!shouldPublishAuthoredMethodology(bundle.authoringStatus)) {
    bundle.methodology = undefined;
  }
  return bundle;
}

/** User-facing label: ACS occupation median earnings, not industry sector. */
export const OCCUPATION_EARNINGS_CHART_TITLE = 'Occupation Median Earnings';
